import { render } from "./register-stepper-user.vue?vue&type=template&id=0966625c&scoped=true&ts=true"
import script from "./register-stepper-user.vue?vue&type=script&lang=ts"
export * from "./register-stepper-user.vue?vue&type=script&lang=ts"

import "./register-stepper-user.vue?vue&type=style&index=0&id=0966625c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0966625c"]])

export default __exports__